export const SET_USER_PROFILE = 'SET_USER_PROFILE';
export const SET_CORRELATION_ID = 'SET_CORRELATION_ID';
export const USER_MIGRATION_STATUS = 'SCHED';
export const USER_ACTIVE_STATUS = 'NOT_LOCKED';
export const MODULE_NAME = 'axp-commercial-reconciliation-root';
export const AMERICAN_EXPRESS_DOMAIN = '.americanexpress.com';
export const SUPPORTED_LANGUAGES = [
  'de-de',
  'en-au',
  'en-gb',
  'en-us',
  'en-ca',
  'es-es',
  'es-mx',
  'fr-ca',
  'fr-fr',
  'it-it',
  'nl-nl',
  'pt-br',
  'sv-se',
];
export const NO_MATCHING_PROFILES = 'noMatchingProfiles';
export const API_STATUS_200 = 200;
export const API_STATUS_401 = 401;
export const API_METHOD_GET = 'GET';
